// extracted by mini-css-extract-plugin
export default {"palette":"d415362f541c552f4e4b","button":"ab75dc735a36f4d133c3"};